import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { spotifyBioMessages as sb } from '../spotify/spotifyBioMessages';
import { profileBioMessages as b } from './profileBioMessages';
import { withBrandWord } from '../../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Profile; each part uses its own slice of it */
import styles from '../Profile.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * "Where it goes" of the bio tool (design c1): Spotify for Artists, the social profiles, the press
 * kit. With Auto upload access (`canUpload`) the note names "Upload bio to Spotify".
 */
const BioWhereItGoesComponent: React.FC<{ artist: string; canUpload: boolean }> = ({ artist, canUpload }) => {
  const intl = useIntl();
  return (
    <aside className={`${styles.rail} ${styles.railAfter}`} data-testid="bio-where">
      <div className={styles.railHead}>
        <b>{intl.formatMessage(b.whereTitle)}</b>
      </div>
      <div className={styles.howTo}>
        <b>{intl.formatMessage(b.whereSpotify)}</b>
        <ol>
          <li>{intl.formatMessage(b.whereSpotify1, { artist })}</li>
          <li>{intl.formatMessage(b.whereSpotify2)}</li>
          <li>{intl.formatMessage(b.whereSpotify3)}</li>
        </ol>
      </div>
      <div className={styles.howTo}>
        <b>{intl.formatMessage(b.whereSocial)}</b>
        <span>{intl.formatMessage(b.whereSocialBody)}</span>
      </div>
      <div className={styles.howTo}>
        <b>{intl.formatMessage(b.wherePress)}</b>
        <span>{intl.formatMessage(b.wherePressBody)}</span>
      </div>
      <p className={styles.note}>{withBrandWord(intl.formatMessage(canUpload ? sb.whereNoteUpload : b.whereNote))}</p>
    </aside>
  );
};

export const BioWhereItGoes = TypedMemo(BioWhereItGoesComponent);
